var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.45966 1.55027C6.85518 0.898209 7.56247 0.5 8.32511 0.5C9.08775 0.5 9.79504 0.898209 10.1926 1.55373L16.3586 11.8474C16.7462 12.5188 16.7485 13.3454 16.3646 14.0189C15.9807 14.6924 15.2683 15.1116 14.4851 15.1202L2.15712 15.1201C1.38193 15.1116 0.66948 14.6924 0.285582 14.0189C-0.0983163 13.3454 -0.0960017 12.5188 0.29757 11.8374L6.45966 1.55027ZM8.94693 2.30463C8.81509 2.08728 8.57932 1.95455 8.32511 1.95455C8.0709 1.95455 7.83513 2.08728 7.70538 2.30117L1.55128 12.5748C1.42206 12.7985 1.42129 13.0741 1.54926 13.2986C1.67722 13.5231 1.91471 13.6628 2.16511 13.6656L14.4771 13.6657C14.7355 13.6628 14.973 13.5231 15.101 13.2986C15.2289 13.0741 15.2282 12.7985 15.1048 12.5848L8.94693 2.30463ZM8.32511 4.93836C8.6933 4.93836 8.99759 5.21196 9.04574 5.56695L9.05238 5.66563V8.57472C9.05238 8.97639 8.72677 9.302 8.32511 9.302C7.95692 9.302 7.65263 9.02839 7.60448 8.67341L7.59784 8.57472V5.66563C7.59784 5.26397 7.92345 4.93836 8.32511 4.93836ZM9.05966 11.4838C9.05966 11.0822 8.73404 10.7565 8.33238 10.7565L8.22642 10.7632C7.87144 10.8113 7.59784 11.1156 7.59784 11.4838C7.59784 11.8855 7.92345 12.2111 8.33238 12.2111L8.43107 12.2044C8.78605 12.1563 9.05966 11.852 9.05966 11.4838Z",
    fill: "#FF4550"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertRed);
export default __webpack_public_path__ + "static/media/alert_red.f0a278f089d2a0a7928ddde59aa87bf7.svg";
export { ForwardRef as ReactComponent };